import type { CustomLightingInfo } from "../../types/sdk";

export type { CustomLightingInfo };

/** 点阵屏默认行列数 */
export const DEFAULT_DOT_MATRIX_ROWS = 7;
export const DEFAULT_DOT_MATRIX_COLS = 7;

export interface DotMatrixProps {
  /** 行数，默认 7 */
  rows?: number;
  /** 列数，默认 7 */
  cols?: number;
  /** 点阵 RGB 数据（行×列） */
  matrixData?: CustomLightingInfo[][] | null;
  /** 全局亮度 0–100 */
  brightness?: number;
  /** 禁用交互 */
  disabled?: boolean;
  /** 选中格 key 列表，格式 `${row}-${col}`，与 buildDotMatrixCellKey 一致 */
  selectedCells?: string[];
  /** 选中角标图（与 Keyboard customColorCornerIconSrc 一致） */
  selectedCornerIconSrc?: string;
  /** 单格边长（px） */
  cellSize?: number;
  /** 格间距（px） */
  cellGap?: number;
  /** 是否在父容器内绝对定位并居中（灯光页虚拟区） */
  fillContainer?: boolean;
  className?: string;
  onCellClick?: (row: number, col: number, event: React.MouseEvent) => void;
  onCellContextMenu?: (
    row: number,
    col: number,
    event: React.MouseEvent
  ) => void;
}
